import { render, staticRenderFns } from "./GolfFee.vue?vue&type=template&id=19aaaf1c"
import script from "./GolfFee.js?vue&type=script&lang=js&external"
export * from "./GolfFee.js?vue&type=script&lang=js&external"
import style0 from "./GolfFee.vue?vue&type=style&index=0&id=19aaaf1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports